export const user = {
  page_heading: "Brukare",
  editor_label_identifier: "ID",
  empty_state_message:
    "Lägg till användare för att bevilja åtkomst och börja hantera behörigheter för denna organization.",
  health_empty_state_message:
    "Lägg till användare för att bevilja åtkomst och börja hantera behörigheter för detta konto.",

  // List Screen
  list_title_prefix: "Användaruppgifter för ",
  list_subtitle_health:
    "Hantera användare som har åtkomst till detta konto. Du kan skapa, redigera eller ta bort användare och kontrollera deras behörigheter.",
  list_subtitle_hr:
    "Hantera användare som har åtkomst till denna organisation. Du kan skapa, redigera eller ta bort användare och kontrollera deras behörigheter.",

  // Add/Edit User Screen
  add_title_prefix: "Lägg till användaruppgifter för ",
  add_subtitle:
    "Skapa en ny användare och tilldela åtkomstbehörigheter. Användaruppgifter och roller kan uppdateras när som helst.",
  edit_title_prefix: "Redigera användaruppgifter för ",
  edit_subtitle:
    "Lägg till användare för att bevilja åtkomst och börja hantera behörigheter för denna organisation.",
  health_edit_subtitle:
    "Lägg till användare för att bevilja åtkomst och börja hantera behörigheter för detta konto.",
  basic_information: "Grundläggande information",

  // Form labels
  identifier_label: "Användarens ID",
  first_name_label: "Förnamn",
  last_name_label: "Efternamn",
  email_label: "E-post",
  phone_number_label: "Telefonnummer",
  location_label: "Plats",

  // Placeholders
  placeholder_identifier: "Skriv användar-ID här...",
  placeholder_first_name: "Skriv förnamn här...",
  placeholder_last_name: "Skriv efternamn här...",
  placeholder_email: "Skriv e-post här...",
  placeholder_phone_number: "Skriv telefonnummer här...",
  placeholder_location: "Skriv plats här...",

  // Messages
  create_success: "Användare skapades framgångsrikt!",
  create_error: "Det gick inte att skapa användare. Försök igen.",
  update_success: "Användare uppdaterades framgångsrikt!",
  update_error: "Det gick inte att uppdatera användare. Försök igen.",
  delete_success: "Användare raderades framgångsrikt!",
  delete_error: "Det gick inte att radera användare. Försök igen.",
  error_identifier_required: "Användar-ID krävs.",
  error_no_home: "Ingen underorganisation vald.",
  error_no_user: "Användare hittades inte.",
};
